var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnderline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5C5F62",
  fillRule: "evenodd",
  d: "M13.467 3.7a.7.7 0 0 1 1.4 0v6.067a4.44 4.44 0 0 1-4.434 4.433 4.4 4.4 0 0 1-3.135-1.298A4.4 4.4 0 0 1 6 9.767V3.7a.7.7 0 0 1 1.4 0v6.067c0 .81.315 1.572.888 2.145a3.01 3.01 0 0 0 2.145.888 3.037 3.037 0 0 0 3.034-3.033zM6.7 15.6h7.467a.7.7 0 1 1 0 1.4H6.7a.7.7 0 0 1 0-1.4",
  clipRule: "evenodd"
})));
export default SvgUnderline;